import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  return <section className="py-24 bg-rose-600 text-white text-center relative overflow-hidden" data-id="element-84">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80&w=2000')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-85" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-87">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-88">
            Empezá hoy a transformar tu cuerpo desde casa.
          </h2>
          <p className="text-xl md:text-2xl text-rose-100 mb-10 font-medium" data-id="element-89">
            No necesitás gimnasio. No necesitás horas de entrenamiento. Solo
            necesitás empezar.
          </p>

          <CTAButton text="EMPEZAR AHORA" subtext="Acceso inmediato • 50% OFF" className="bg-white text-rose-600 hover:bg-gray-50 hover:shadow-[0_0_40px_rgba(255,255,255,0.3)]" data-id="element-90" />
        </motion.div>
      </div>
    </section>;
}